/**
 * Webpack Chunk Load Retry
 *
 * Intercepta los errores de carga de chunks y reintenta con cache-busting.
 * Esto resuelve problemas intermitentes donde un chunk falla por:
 * - Cache stale post-deploy (el browser tiene un manifest viejo)
 * - Problemas transitorios de red/CDN
 * - Service worker sirviendo referencias desactualizadas
 *
 * Se debe importar lo más temprano posible en el entry point.
 */

const MAX_RETRIES = 2
const RETRY_DELAY_MS = 1000
const retriedChunks = new Map<string, number>()

export function installChunkRetry (): void {
  if (typeof __webpack_require__ === 'undefined') return

  const originalEnsureChunk = __webpack_require__.e

  if (typeof originalEnsureChunk !== 'function') return

  __webpack_require__.e = function (chunkId: string) {
    return originalEnsureChunk(chunkId).catch((error: Error) => {
      const retryCount = retriedChunks.get(chunkId) ?? 0

      if (retryCount >= MAX_RETRIES) {
        console.error(`[chunk-retry] Chunk ${chunkId} failed after ${MAX_RETRIES} retries`, error)
        throw error
      }

      retriedChunks.set(chunkId, retryCount + 1)

      console.warn(`[chunk-retry] Chunk ${chunkId} failed, retry ${retryCount + 1}/${MAX_RETRIES}`)

      // Eliminar el script fallido para que webpack lo reintente
      const scripts = document.querySelectorAll(`script[src*="/${chunkId}."]`)
      scripts.forEach(script => script.remove())

      return new Promise<void>((resolve) => {
        setTimeout(resolve, RETRY_DELAY_MS)
      }).then(() => __webpack_require__.e(chunkId))
    })
  }
}

// Declaración de tipos para __webpack_require__
declare const __webpack_require__: {
  e: (chunkId: string) => Promise<any>
}
